import React, { Fragment } from "react";
import Select from "react-select";
import "./EditVariant.css";
import { Link } from 'react-router-dom';
import { isNumber, isFloat, required, length } from "../../../util/validators";

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  theme: (styles) => ({ ...styles, borderRadius: "8px" }),
};
 
const LeadTime = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
];

const POST_FORM = {
  selectedWarranty: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required],
  },
  // selectedSize: {
  //   value: [],
  //   valid: false,
  //   errorMessage: "",
  //   touched: false,
  //   validators: [required],
  // },
  // selectedColor: {
  //   value: [],
  //   valid: false,
  //   errorMessage: "",
  //   touched: false,
  //   validators: [required],
  // },
  lead_time: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required],
  },


  order_limit: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required, isNumber],
  },
  marketable_stock: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required, isNumber],
  },
  reference_price: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required, isFloat],
  },
  price: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required, isFloat],
  },
  foreign_price: {
    value: "",
    valid: true,
    errorMessage: "",
    touched: false,
    validators: [ isFloat],
  },


  package_length: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required, isFloat],
  },
  package_width: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required, isFloat],
  },
  package_height: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required, isFloat],
  },
  package_weight: {
    value: "",
    valid: false,
    errorMessage: "",
    touched: false,
    validators: [required, isFloat],
  },
};

class EditVariant extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      formIsValid: false,
      isActive: true,
      foreign_price_isActive: false,
      variantForm: POST_FORM,
    };

    this.inputSelectChangeHandler = this.inputSelectChangeHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangePrice = this.handleChangePrice.bind(this);
    this.inputChangeHandler = this.inputChangeHandler.bind(this);
  }

  componentDidMount() {
    const postForm = {
      lead_time: {
        ...this.state.variantForm.lead_time,
        value: LeadTime[this.props.variantData.lead_time-1],
        valid: true
      },
      order_limit: {
        ...this.state.variantForm.order_limit,
        value: this.props.variantData.order_limit,
        valid: true
      },
      marketable_stock: {
        ...this.state.variantForm.marketable_stock,
        value: this.props.variantData.marketable_stock,
        valid: true
      },
      reference_price: {
        ...this.state.variantForm.reference_price,
        value: this.props.variantData.reference_price,
        valid: true
      },
      price: {
        ...this.state.variantForm.price,
        value: this.props.variantData.price,
        valid: true
      },
      foreign_price: {
        ...this.state.variantForm.foreign_price,
        value: this.props.variantData.foreign_price,
        valid: true
      },
      package_length: {
        ...this.state.variantForm.package_length,
        value: this.props.variantData.package_length,
        valid: true
      },
      package_width: {
        ...this.state.variantForm.package_width,
        value: this.props.variantData.package_width,
        valid: true
      },
      package_height: {
        ...this.state.variantForm.package_height,
        value: this.props.variantData.package_height,
        valid: true
      },
      package_weight: {
        ...this.state.variantForm.package_weight,
        value: this.props.variantData.package_weight,
        valid: true
      },
    };
    this.setState({ variantForm: postForm, foreign_price_isActive: this.props.variantData.foreign_price_isActive, isActive: this.props.variantData.isActive ,formIsValid: true });
  }

  updateVariantHandler = (data) => {
    // console.log(data.id);
    const graphqlQuery = {
        query: `
        mutation UpdateVariant($code: Int!, $isActive: Boolean!, $lead_time: Int!, $order_limit: Int!, $marketable_stock: Int!, $reference_price: Float!, $price: Float!, $foreign_price: Float, $foreign_price_isActive: Boolean!, $package_length: Float!, $package_width: Float!, $package_height: Float!, $package_weight: Float!) {
          updateVariant(code: $code, VariantInput: {isActive: $isActive, lead_time: $lead_time, order_limit: $order_limit, marketable_stock: $marketable_stock, reference_price: $reference_price, price: $price, foreign_price: $foreign_price, foreign_price_isActive: $foreign_price_isActive, package_length: $package_length, package_width: $package_width, package_height: $package_height, package_weight: $package_weight}) {
            id
            lead_time
            order_limit
            marketable_stock
            reference_price
            price
            foreign_price
            foreign_price_isActive
            package_length
            package_width
            package_height
            package_weight
            isActive
          }
        }
        `,
        variables: {
          code: parseInt(data.id),
          isActive: this.state.isActive,
          lead_time: parseInt(this.state.variantForm["lead_time"].value.value),
          order_limit: parseInt(this.state.variantForm["order_limit"].value),
          marketable_stock: parseInt(this.state.variantForm["marketable_stock"].value),
          reference_price: parseFloat(this.state.variantForm["reference_price"].value),
          price: parseFloat(this.state.variantForm["price"].value),
          foreign_price: parseFloat(this.state.variantForm["foreign_price"].value),
          foreign_price_isActive: this.state.foreign_price_isActive,
          package_length: parseFloat(this.state.variantForm["package_length"].value),
          package_width: parseFloat(this.state.variantForm["package_width"].value),
          package_height: parseFloat(this.state.variantForm["package_height"].value),
          package_weight: parseFloat(this.state.variantForm["package_weight"].value),
        },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + this.props.token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(graphqlQuery)
    })
      .then(res => {
        return res.json();
      })
      .then(resData => {
        
        if (resData.errors) {
          throw new Error('خطا در بروزرسانی تنوع کالایی!');
        }
        this.props.toggleVariantClass({index: this.props.index});

        this.props.loadVariant(resData.data.updateVariant);
        // this.setState(prevState => {
        //   const updatedPosts = prevState.posts.filter(p => p.id !== postId);
        //   return { posts: updatedPosts, postsLoading: false };
        // });
      })
      .catch(err => {
        console.log(err);
        this.setState({ postsLoading: false });
      });
  };
  
  handleValidation() {
    if (this.state.formIsValid) {
      return true;
    }

    this.setState((prevState) => {
      let updatedForm = { ...prevState.variantForm };
      for (const inputName in prevState.variantForm) {
        let isValid = true;
        let errorMessage = "";
        if ( inputName === "selectedWarranty" || inputName === "lead_time" ) {
          for (const validator of prevState.variantForm[inputName].validators) {
            isValid = isValid && validator(prevState.variantForm[inputName].value.value).hasError;
            errorMessage = !isValid && errorMessage === "" ? validator(prevState.variantForm[inputName].value.value).errorMessage : errorMessage;
          }
        } else {
          if (this.props.variantData.dataTheme === 1) {
            for (const validator of prevState.variantForm[inputName].validators) {
              isValid = isValid && validator(prevState.variantForm[inputName].value).hasError;
              errorMessage = !isValid && errorMessage === "" ? validator(prevState.variantForm[inputName].value).errorMessage : errorMessage;
            }
          }else{
            if (inputName === "order_limit" || inputName === "marketable_stock" || inputName === "reference_price" || inputName === "price" || inputName === "foreign_price") {
              for (const validator of prevState.variantForm[inputName].validators) {
                isValid = isValid && validator(prevState.variantForm[inputName].value).hasError;
                errorMessage = !isValid && errorMessage === "" ? validator(prevState.variantForm[inputName].value).errorMessage : errorMessage;
              }
            }            
          }          
        }
        updatedForm = {
          ...updatedForm,
          [inputName]: {
            ...updatedForm[inputName],
            valid: isValid,
            errorMessage: errorMessage,
          },
        };
      }
      return {
        variantForm: updatedForm,
      };
    });
  }


  inputChangeHandler(event) {
    const val = event.target;
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.variantForm[val.id].validators) {
        isValid = isValid && validator(val.value).hasError;
        errorMessage = !isValid && errorMessage === "" ? validator(val.value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.variantForm,
        [val.id]: {
          ...prevState.variantForm[val.id],
          valid: isValid,
          value: val.value,
          errorMessage: errorMessage,
        },
      };

      let formIsValid = true;
      for (const inputName in updatedForm) {
        if (this.props.variantData.dataTheme === 1) {
          formIsValid = formIsValid && updatedForm[inputName].valid;
        }else{
          if (inputName === "order_limit" || inputName === "marketable_stock" || inputName === "reference_price" || inputName === "price" || inputName === "foreign_price" || inputName === "selectedWarranty" || inputName === "lead_time") {
            formIsValid = formIsValid && updatedForm[inputName].valid;
          }            
        }
      }

      return {
        variantForm: updatedForm,
        formIsValid: formIsValid,
        touched: true
      };
    });
  }

  inputSelectChangeHandler(event, selector) {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.variantForm[selector.name]
        .validators) {
        isValid = isValid && validator(event.value.toString()).hasError;
        errorMessage = !isValid && errorMessage === "" ? validator(event.value.toString()).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.variantForm,
        [selector.name]: {
          ...prevState.variantForm[selector.name],
          valid: isValid,
          value: event,
          errorMessage: errorMessage,
        },
      };
      
      let formIsValid = true;
      for (const inputName in updatedForm) {
        if (this.props.variantData.dataTheme === 1) {
          formIsValid = formIsValid && updatedForm[inputName].valid;
        }else{
          if (inputName === "order_limit" || inputName === "marketable_stock" || inputName === "reference_price" || inputName === "price" || inputName === "foreign_price" || inputName === "selectedWarranty" || inputName === "lead_time") {
            formIsValid = formIsValid && updatedForm[inputName].valid;
          }            
        }
      }

      return {
        variantForm: updatedForm,
        formIsValid: formIsValid,
        touched: true
      };
    });
  }

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        variantForm: {
          ...prevState.variantForm,
          [input]: {
            ...prevState.variantForm[input],
            touched: true,
          },
        },
      };
    });
  };

  handleChange(event) {
    if (event.target.id === "isActive") {
      this.setState({ touched: true, isActive: event.target.checked });
    }
  }

  handleChangePrice(event) {
    if (event.target.id === "foreign_price_isActive") {
      this.setState({ touched: true, foreign_price_isActive: event.target.checked });
    }
  }


  render() {
    return (
      <Fragment>
        <form id="editVariant_22424206">
            <input type="hidden" name="product_variant[product_id]" value="530113"/>
            <input type="hidden" name="product_variant[product_variant_id]" value="22424206"/>
            <div className="c-variation-diversity__separator">
                <div className="mn-variant__secondary-info">
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">قیمت مرجع (ریال):</span>
                        <span type="text" className="mn-variant__info--main"><span dir="ltr" data-debug="۱۱۵۰۰۰۰">{this.props.variantData.reference_price}</span></span>
                    </div>
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">قیمت فروش (ریال):</span>
                        <span className="mn-variant__info--main js-view-price"><span dir="ltr" data-debug="۱۰۴۶۲۰۰">{this.props.variantData.price}</span></span>
                    </div>
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">بازه زمانی ارسال (روز):</span>
                        <span className="mn-variant__info--main js-view-lead-time">{this.props.variantData.lead_time}</span>
                    </div>
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">حداکثر سفارش در سبد (عدد):</span>
                        <span className="mn-variant__info--main js-view-order-limit">{this.props.variantData.order_limit}</span>
                    </div>
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">موجودی نزد شما (عدد):</span>
                        <span className="mn-variant__info--main js-view-marketplace-seller-stock">{this.props.variantData.marketable_stock}</span>
                    </div>
                </div>
                {this.props.variantData.dataTheme == 1 && (
                <div className="mn-variant__secondary-info">
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">طول (سانتیمتر):</span>
                        <span type="text" className="mn-variant__info--main js-view-package-length">{this.props.variantData.package_length}</span>
                    </div>
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">عرض (سانتیمتر):</span>
                        <span className="mn-variant__info--main js-view-package-width">{this.props.variantData.package_width}</span>
                    </div>
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">ارتفاع (سانتیمتر):</span>
                        <span className="mn-variant__info--main js-view-package-height">{this.props.variantData.package_height}</span>
                    </div>
                    <div className="mn-variant__secondary-item"> <span className="mn-variant__info">وزن (گرم):</span>
                        <span className="mn-variant__info--main js-view-package-weight">{this.props.variantData.package_weight}</span>
                    </div>
                </div>
                )}
                <div className="c-variation-diversity__warning js-save-warning"></div>
                <div className="mn-variant__secondary-info mn-variant__secondary-info--edit" id="metaEditFormVariant_22424206">
                    <div className="mn-grid__row mn-grid__row--gap-lg">
                        {/* <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--flex-initial">
                            <label className="uk-form-label">کانال فروش: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper field-wrapper--background uk-flex uk-flex-middle js-radio-group">
                                <label className="c-ui-radio c-ui-radio--gap-sm disabled">
                                    <input type="radio" className="c-ui-radio__origin js-site-digikala" name="product_variant[site]" value="digikala" data-default-value="1" checked="" disabled=""/> <span className="c-ui-radio__check c-ui-radio__check--small"></span>
                                    <span className="c-ui-radio__label">دیجی‌کالا</span>
                                </label>
                                <label className="c-ui-radio c-ui-radio--gap-sm disabled">
                                    <input type="radio" className="c-ui-radio__origin js-site-digistyle" name="product_variant[site]" value="seller" data-default-value="0" disabled=""/> <span className="c-ui-radio__check c-ui-radio__check--small"></span>
                                    <span className="c-ui-radio__label">دیجی‌استایل</span>
                                </label>
                                <label className="c-ui-radio c-ui-radio--gap-sm disabled">
                                    <input type="radio" className="c-ui-radio__origin js-site-both" name="product_variant[site]" value="both" data-default-value="0" disabled=""/> <span className="c-ui-radio__check c-ui-radio__check--small"></span>
                                    <span className="c-ui-radio__label">دیجی‌کالا و دیجی‌استایل</span>
                                </label>
                            </div>
                        </div>
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--flex-initial">
                            <label className="uk-form-label">ارسال توسط: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper field-wrapper--background uk-flex uk-flex-middle js-checkbox-group-container">
                                <label className="c-ui-checkbox c-ui-checkbox--gap-sm disabled">
                                    <input type="checkbox" className="c-ui-checkbox__origin js-checkbox-group js-shipping-type-digikala" name="product_variant[shipping_type_digikala]" data-default-value="1" value="1" checked=""/> <span className="c-ui-checkbox__check c-ui-checkbox__check--small"></span>
                                    <span className="c-ui-checkbox__label">دیجی‌کالا</span>
                                </label>
                                <label className="c-ui-checkbox c-ui-checkbox--gap-sm disabled">
                                    <input type="checkbox" className="c-ui-checkbox__origin js-checkbox-group js-shipping-type-seller" name="product_variant[shipping_type_seller]" data-default-value="0" value="1" disabled=""/> <span className="c-ui-checkbox__check c-ui-checkbox__check--small"></span>
                                    <span className="c-ui-checkbox__label">فروشنده</span>
                                </label>
                            </div>
                        </div> */}
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--flex-initial">
                            <label htmlFor="isActive" className="uk-form-label">
                            فعال / غیرفعال: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="mn-field-wrapper field-wrapper--background">
                            <label className="mn-ui-checkbox--container">
                                <input
                                type="checkbox"
                                className="mn-ui-checkbox__checkbox"
                                name="isActive"
                                id="isActive"
                                value="1"
                                onChange={this.handleChange}
                                checked={this.state.isActive}
                                />
                                <span className="mn-ui-checkbox__checkmark"></span>
                                <span className="mn-ui-checkbox__label">
                                فعال / غیرفعال
                                </span>
                            </label>
                            </div>
                        </div>
                   
                    {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                  
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--flex-initial">
                            <label htmlFor="foreign_price_isActive" className="uk-form-label">
                            قیمت بر مبنای درهم محاسبه شود: 
                            </label>
                            <div className="mn-field-wrapper field-wrapper--background">
                            <label className="mn-ui-checkbox--container">
                                <input
                                type="checkbox"
                                className="mn-ui-checkbox__checkbox"
                                name="foreign_price_isActive"
                                id="foreign_price_isActive"
                                value="1"
                                onChange={this.handleChangePrice}
                                checked={this.state.foreign_price_isActive}
                                />
                                <span className="mn-ui-checkbox__checkmark"></span>
                                <span className="mn-ui-checkbox__label">
                                فعال / غیرفعال
                                </span>
                            </label>
                            </div>
                        </div>
                    
                    <div className="mn-grid__col c-ui--mt-20 mn-grid__col--sm-3 mn-grid__col--flex-initial">
                        <label className="uk-form-label">قیمت فروش (درهم):
                        </label>
                        <div
                            className={[
                                "field-wrapper",
                                this.state.variantForm["foreign_price"].errorMessage === ""
                                ? ""
                                : "has-error",
                            ].join(" ")}
                            >
                            <input
                                id="foreign_price"
                                type="text"
                                placeholder=""
                                className="mn-content-input__origin"
                                value={this.state.variantForm["foreign_price"].value}
                                name="foreign_price"
                                onChange={this.inputChangeHandler}
                                onBlur={this.inputBlurHandler.bind(this, "foreign_price")}
                                required=""
                            />
                            <div id={2} className="error error-msg">
                                {this.state.variantForm["foreign_price"].errorMessage}
                            </div>
                        </div>
                        <div></div>
                    </div>
                    </div>
                    {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                    <div className="uk-flex uk-flex-wrap mt-30 w-100">
                        <div className="mn-grid__col c-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial"> 
                            <label className="uk-form-label">بازه زمانی ارسال (روز): <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper ui-select ui-select__container">
                                <div className={["field-wrapper",
                                        this.state.variantForm["lead_time"].errorMessage === "" ? "" : "has-error",
                                    ].join(" ")}>      
                                        <Select
                                            name="lead_time"
                                            control="input"
                                            value={this.state.variantForm["lead_time"].value}
                                            options={LeadTime}
                                            styles={colourStyles}
                                            theme={colourStyles.theme}
                                            onChange={this.inputSelectChangeHandler}
                                            onBlur={this.inputBlurHandler.bind(this, "lead_time")}
                                            value={this.state.variantForm["lead_time"].value}
                                            valid={this.state.variantForm["lead_time"].valid}
                                            touched={this.state.variantForm["lead_time"].touched}
                                        />
                                                                        
                                    <div id={2} className="error error-msg">
                                        {this.state.variantForm["lead_time"].errorMessage}
                                    </div>
                                </div>
                                <div></div>
                            </div>
                        </div>
                        <div className="mn-grid__col c-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial"> 
                            <label htmlFor="" className="uk-form-label">حداکثر سفارش در سبد (عدد): <span className="uk-form-label__required"></span>
                            </label>
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["order_limit"].errorMessage === ""
                                    ? ""
                                    : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="order_limit"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["order_limit"].value}
                                    name="order_limit"
                                    onChange={this.inputChangeHandler}
                                    onBlur={this.inputBlurHandler.bind(this, "order_limit")}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["order_limit"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div className="mn-grid__col c-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial"> 
                            <label className="uk-form-label">موجودی نزد شما (عدد): <span className="uk-form-label__required"></span>
                            </label>
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["marketable_stock"].errorMessage === ""
                                    ? ""
                                    : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="marketable_stock"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["marketable_stock"].value}
                                    name="marketable_stock"
                                    onChange={this.inputChangeHandler}
                                    onBlur={this.inputBlurHandler.bind(this, "marketable_stock")}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["marketable_stock"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        {/* <div className="mn-grid__col c-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial"> 
                        <span className="uk-form-label">کد محصول فروشنده: </span>
                            <div className="field-wrapper">
                                <input type="text" name="product_variant[supplier_code]" className="uk-input js-edit-seller-code" data-default-value="" value=""/>
                            </div>
                        </div> */}
                        <div className="mn-grid__col c-ui--mt-20 mn-grid__col--sm-3 mn-grid__col--flex-initial">
                            <label className="uk-form-label">قیمت مرجع (ریال):</label>
                            {/* <div className="field-wrapper">
                                <input type="text" className="uk-input disabled" value="911166" disabled=""/>
                            </div> */}
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["reference_price"].errorMessage === ""
                                    ? ""
                                    : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="reference_price"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["reference_price"].value}
                                    name="reference_price"
                                    onChange={this.inputChangeHandler}
                                    onBlur={this.inputBlurHandler.bind(this, "reference_price")}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["reference_price"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div className="mn-grid__col c-ui--mt-20 mn-grid__col--sm-3 mn-grid__col--flex-initial">
                            <label className="uk-form-label">قیمت فروش (ریال): <span className="uk-form-label__required"></span>
                            </label>
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["price"].errorMessage === ""
                                    ? ""
                                    : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="price"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["price"].value}
                                    name="price"
                                    onChange={this.inputChangeHandler}
                                    onBlur={this.inputBlurHandler.bind(this, "price")}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["price"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        {this.props.variantData.dataTheme == 1 && (
                        <Fragment>
                        <div className="mt-30 uk-width-1-3">
                            <label for="" className="uk-form-label">ابعاد بسته‌بندی (سانتیمتر): <span className="uk-form-label__required"></span>
                            </label>
                            <div className="mn-grid__row mn-grid__row--gap-small mn-grid__row--nowrap-sm">
                                <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial">
                                    <div
                                        className={[
                                            "field-wrapper",
                                            this.state.variantForm["package_length"]
                                            .errorMessage === ""
                                            ? ""
                                            : "has-error",
                                        ].join(" ")}
                                        >
                                        <label className="mn-content-input">
                                            {" "}
                                            <span className="mn-content-input__text mn-content-input__text--overlay">
                                            طول
                                            </span>
                                            <input
                                            id="package_length"
                                            type="text"
                                            placeholder=""
                                            className="mn-content-input__origin mn-content-input__origin--overlay"
                                            value={this.state.variantForm["package_length"].value}
                                            onChange={this.inputChangeHandler}
                                            onBlur={this.inputBlurHandler.bind(this, "package_length")}
                                            name="package_length"
                                            />
                                        </label>
                                        <div id={2} className="error error-msg">
                                            { this.state.variantForm["package_length"].errorMessage }
                                        </div>
                                    </div>
                                </div>
                                <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                                    <div
                                        className={[
                                            "field-wrapper",
                                            this.state.variantForm["package_width"]
                                            .errorMessage === ""
                                            ? ""
                                            : "has-error",
                                        ].join(" ")}
                                        >
                                        <label className="mn-content-input">
                                            {" "}
                                            <span className="mn-content-input__text mn-content-input__text--overlay">
                                            عرض
                                            </span>
                                            <input
                                            id="package_width"
                                            type="text"
                                            placeholder=""
                                            className="mn-content-input__origin mn-content-input__origin--overlay"
                                            value={this.state.variantForm["package_width"].value}
                                            onChange={this.inputChangeHandler}
                                            onBlur={this.inputBlurHandler.bind(this, "package_width")}
                                            name="package_width"
                                            />
                                        </label>
                                        <div id={2} className="error error-msg">
                                            {
                                            this.state.variantForm["package_width"]
                                                .errorMessage
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                                    <div
                                        className={[
                                            "field-wrapper",
                                            this.state.variantForm["package_height"]
                                            .errorMessage === ""
                                            ? ""
                                            : "has-error",
                                        ].join(" ")}
                                        >
                                        <label className="mn-content-input">
                                            {" "}
                                            <span className="mn-content-input__text mn-content-input__text--overlay">
                                            ارتفاع
                                            </span>
                                            <input
                                            id="package_height"
                                            type="text"
                                            placeholder=""
                                            className="mn-content-input__origin mn-content-input__origin--overlay"
                                            value={this.state.variantForm["package_height"].value}
                                            onChange={this.inputChangeHandler}
                                            onBlur={this.inputBlurHandler.bind(this, "package_height")}
                                            name="package_height"
                                            />
                                        </label>
                                        <div id={2} className="error error-msg">
                                            { this.state.variantForm["package_height"].errorMessage }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-15 uk-margin-large-right mn-variant__secondary-item mn-variant__secondary-item--edit">
                            <label for="" className="uk-form-label">وزن بسته بندی (گرم): <span className="uk-form-label__required"></span>
                            </label>
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["package_weight"]
                                    .errorMessage === ""
                                    ? ""
                                    : "has-error",
                                ].join(" ")}
                                >
                                <label className="mn-content-input">
                                    {" "}
                                    <span className="mn-content-input__text mn-content-input__text--overlay">
                                    وزن
                                    </span>
                                    <input
                                    id="package_weight"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin mn-content-input__origin--overlay"
                                    value={this.state.variantForm["package_weight"].value}
                                    onChange={this.inputChangeHandler}
                                    onBlur={this.inputBlurHandler.bind(this, "package_weight")}
                                    name="package_weight"
                                    />
                                </label>
                                <div id={2} className="error error-msg">
                                    { this.state.variantForm["package_weight"].errorMessage }
                                </div>
                            </div>
                        </div>
                        </Fragment>
                        )}
                        <div className="mn-variant__btn-controls">
                            <div className="has-error has-error--footer js-edit-error hidden"></div>
                                           
                            <button type="button" className={["c-ui-btn c-ui-btn--next mr-a js-variant-save-edit", this.state.touched ? "" : "disabled" ].join(" ")} data-id={this.props.variantData.id} onClick={this.updateVariantHandler.bind(this, {id: this.props.variantData.id})}>ذخیره سازی</button>
                            <button type="button" className="mn-content-categories__search-reset js-variant-cancel-edit" data-id="22424206" onClick={this.props.toggleVariantClass.bind(this, {index: this.props.index})}></button>
                        </div>
                    </div>
                    {/* <div className="c-content-loader">
                        <div className="c-content-loader__logo"></div>
                        <div className="c-content-loader__spinner"></div>
                    </div> */}
                </div>
            </div>
        </form>
      </Fragment>
    );
  }
}

export default EditVariant;
